import Vue from 'vue'
import Bugsnag from '@bugsnag/js'
import VueRouter from 'vue-router';
import VuePortal from 'portal-vue';
import { Tooltip } from 'floating-vue';
import Components from './utils/componentImports'
import {stringifyQuery} from "./utils/stringifyQuery";

window.Vue = Vue;

const bugsnagClient = typeof Bugsnag.getClient === 'function' ? Bugsnag.getClient() : null;
const bugsnagVue = bugsnagClient ? bugsnagClient.getPlugin('vue') : null;
if (bugsnagVue && typeof bugsnagVue.installVueErrorHandler === 'function') {
    bugsnagVue.installVueErrorHandler(Vue);
}

Vue.use(VueRouter);
Vue.use(VuePortal);
Vue.component('v-tooltip', Tooltip);
Vue.use(Components)

/**
 * BASKET
 */
window.Orbit = new Vue({
    data() {
        return {
            basket: null,
        };
    },
});

export const App = Vue.extend({
    comments: true, // imported for Storyblok live editor to work
    router: window.USE_ROUTER ? new VueRouter({
        mode: 'history',
        stringifyQuery,
        routes: [
            { path: '/', component: { template: '<div>blank</div>' } },
        ],
    }) : undefined,

    data: function() {
        return {
            google: false,
        }
    },

    mounted() {
        this.disallowDoubleSubmissions();
    },

    methods: {
        disallowDoubleSubmissions() {
            document.addEventListener('submit', e => {
                if (e.target.hasAttribute('disabled')) {
                    e.preventDefault();

                    return;
                }

                e.target.setAttribute('disabled', true);
            });
        },

        loadValues(dataObject, initialValues) {
            if (typeof initialValues == 'undefined' && typeof window.initialValues !== 'undefined') {
                initialValues = window.initialValues
            }
            for (const prop in dataObject) {
                if (initialValues[prop]) {
                    dataObject[prop] = initialValues[prop]
                }
            }
            return dataObject
        }
    },
})
